import { render, staticRenderFns } from "./footerEgazarOld.vue?vue&type=template&id=4ca53a5e"
import script from "./footerEgazarOld.vue?vue&type=script&lang=js"
export * from "./footerEgazarOld.vue?vue&type=script&lang=js"
import style0 from "./footerEgazarOld.vue?vue&type=style&index=0&id=4ca53a5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports